<template>
  <a-popconfirm
    v-if="type === 'list'"
    :title="'删除后将无法恢复，请谨慎操作！'"
    placement="bottomRight"
    @confirm="handleOk"
    class="append-to-table"
  >
    <a href="javascript:void(0);" @click="deleteRow()">删除</a>
  </a-popconfirm>

  <a-button v-else danger @click="handleDelete()">删除</a-button>
  <a-modal :confirmLoading="loading" :centered="true" v-model:visible="visible" @ok="handleOk()">
    <template #title>
      <h4 class="flow-model-title">删除</h4>
    </template>
    <div class="flow-model__subtitle mt14">删除原因</div>
    <a-textarea
      show-count
      v-model:value="approvalContent"
      :placeholder="'请输入删除原因，最多200字'"
      :auto-size="{ minRows: 3 }"
      :maxlength="200"
      allowClear
    />
  </a-modal>
</template>

<script lang="ts">
import { getCurrentUserId } from "@/utils";
import { Modal, message } from "ant-design-vue";
import { TabService } from "@/core";
import { PropType, computed, defineComponent, reactive, toRefs,createVNode } from "vue";
import { ExclamationCircleOutlined } from "@ant-design/icons-vue";
import { reconnoiterBtnService } from "./service";
import { useRouter } from "vue-router";
export default defineComponent({
  isGlobal: true,
  name: "noFlowDeleteBtn",
  props: {
    type: {
      type: String,
      default: "list",
    },
    bizIdKey: {
      //对应id key值
      type: String,
      default: "id",
    },
    bizType: {
      type: String,
      required: true,
    },
    record: {
      type: Object as PropType<any>,
    },
    backUrl: {
      type: String,
      default: "",
    },
  },
  emits: ["refresh"],
  setup(props, { emit }) {
    const state = reactive(<{
        approvalContent: string;
        loading: boolean;
        visible: boolean;
        currentUserId: string;
      }
    >{
      approvalContent: "",
      loading: false,
      visible: false,
      currentUserId: getCurrentUserId(),
    });
    const router = useRouter();
    const { run: runDelete, loading: submitLoading = false } = reconnoiterBtnService.useDeleteApi();
    const deleteRow = () => {
      // state.approvalContent = "";
      // state.visible = true;
    };
    const handleOk = async () => {
      // if (!state.approvalContent) {
      //   message.warning("请填写删除原因");
      //   return;
      // }
      // state.visible = true;

      await runDelete([props.record[props.bizIdKey]]);

      emit("refresh");
    };
    const handleDelete=()=>{
      Modal.confirm({
        title: "警告",
        icon: createVNode(ExclamationCircleOutlined),
        content: "删除后将无法恢复，请谨慎操作！",
        okText: "确定",
        centered: true,
        cancelText: "取消",
        onOk: async () => {
          await runDelete([props.record[props.bizIdKey]]);
          if(props.backUrl){
            router.push(props.backUrl);
          }else{
            TabService.closeCurrentTab();
            router.back();
          }
         
        },
        onCancel() {
          // console.log("Cancel");
        },
      });
    }
    return {
      ...toRefs(state),
      deleteRow,
      handleOk,handleDelete
    };
  },
});
</script>
<style scoped>
.flow-model-title {
  margin-bottom: 0;
  font-weight: 600;

  display: inline-block;
}
.flow-model__subtitle {
}
.mt14 {
  margin-top: -14px;
}
.flow-model-subtitle {
  font-size: 14px;
  padding-left: 10px;
}
</style>
